/**
 * The light rim that makes a dark disc readable on a dark surface — black
 * checkers on dark squares, dark felt, dark points and each other. A dark
 * piece's own border is around 1.3:1 against those; this rim is 4:1 or better
 * in every theme (WCAG 1.4.11 asks 3:1 for a graphical object's edge).
 */
export const DARK_RIM_COLOR = "rgba(255, 236, 205, 0.55)";
const DARK_RIM_WIDTH = 1.5;
/** How far outside the disc's radius the rim is centred: just past its border. */
const DARK_RIM_OFFSET = 1.25;

/** Stroke the rim around a disc of `radius` centred on `(x, y)`. */
export function drawDarkDiscRim(ctx: CanvasRenderingContext2D, x: number, y: number, radius: number): void {
  ctx.beginPath();
  ctx.arc(x, y, radius + DARK_RIM_OFFSET, 0, Math.PI * 2);
  ctx.strokeStyle = DARK_RIM_COLOR;
  ctx.lineWidth = DARK_RIM_WIDTH;
  ctx.stroke();
}
